// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/partial-panel.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/partial-panel/partial-panel.js';

mount([g0]);
